// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal","more-modal":"more-modal","modal-background":"modal-background","modal-content":"modal-content"};